import { MobileMenuFlyout } from "./MobileMenuFlyout";
import { MobileMenuBottomBar } from "./MobileMenuBottomBar";
import { MobileMenuItem } from "./MobileMenuItem";

export const MobileMenu = {
  Flyout: MobileMenuFlyout,
  BottomBar: MobileMenuBottomBar,
  Item: MobileMenuItem,
};
